export function replacePathParams(str: string, obj: Record<string, any>) {
    if (!obj) return str;
    return str?.replace(/\{(\w+)\}/g, (a, b) => {
        const type = typeof obj?.[b];
        if (type === 'string' || type === 'number' || type === 'boolean') {
            return obj?.[b];
        }
        return a;
    });
}
